(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.stickyType = this.getAttribute('data-sticky-type');

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.stickyType === 'always' || this.stickyType === 'reduce-logo-size') {
        this.header.classList.add('shopify-section-header-sticky');
      }

      if (this.stickyType === 'on-scroll-up') {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, { passive: true });
        this.createObserver();
      }

      this.predictiveSearch = this.querySelector('predictive-search');
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      const scrollThreshold = 150;

      if (scrollTop > this.currentScrollTop && scrollTop > scrollThreshold) {
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-visible');
        this.closeMenuDisclosure();
        this.closeSearchModal();
      } 
      else if (scrollTop < this.currentScrollTop && scrollTop > scrollThreshold) {
        this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-visible');
        this.header.classList.remove('shopify-section-header-hidden');
      } 
      else if (scrollTop <= scrollThreshold) {
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'shopify-section-header-visible');
      }
      this.currentScrollTop = scrollTop;
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
